import(/* webpackMode: "eager" */ "/opt/build/repo/app/(chat)/feedback/page.tsx");
